function EmptyIcon() {
    return (
        <span></span>
    )
}

export { EmptyIcon }